import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { useQueryClient } from "@tanstack/react-query";
import { useWindowSize } from "../../../../../Helpers";
import Button from "@components/Button";
import "./style.scss";
import LinearGradientProgressBar from "@components/LinearGradientProgressBar";
import StickyButton from "../../../../../components/StickyButton";
import PagesHeader from "@components/PagesHeader";
import StickyContent from "@components/StickyContent";
import BrandLogo from "@components/BrandLogo";
import DOMPurify from "dompurify";

export default function DominantAnswerContent({
  currentQuestion,
  setCurrentQuestion,
  setAnswers,
  answers,
  sendAnswers,
}) {
  const { ident } = useParams();
  const { width } = useWindowSize();
  const queryClient = useQueryClient();
  const gameQuestionsQuery = queryClient.getQueryData([
    "game-questions",
    ident,
  ]);
  const XGA = width >= 1020;
  const isUltraInsider =
    location.pathname.includes("/ultra-insider") ||
    location.pathname.includes("/ultrainsider");

  const handleNextButtonClick = () => {
    const currentQuestionIdent =
      gameQuestionsQuery.content[currentQuestion].ident;

    setAnswers((prevAnswers) => {
      const alreadyAnswered = prevAnswers.find(
        (a) => a.question_ident === currentQuestionIdent,
      );

      if (!alreadyAnswered) {
        return [
          ...prevAnswers,
          {
            question_ident: currentQuestionIdent,
            answer_ident: "null",
          },
        ];
      }

      return prevAnswers;
    });

    setCurrentQuestion(currentQuestion + 1);
  };

  const getMostFrequentAnswer = (answers) => {
    const counts = answers.reduce((acc, obj) => {
      const ident = obj.answer_ident;
      acc[ident] = (acc[ident] || 0) + 1;
      return acc;
    }, {});

    return Object.keys(counts).reduce((a, b) =>
      counts[a] >= counts[b] ? a : b,
    );
  };

  const dominantIdent = getMostFrequentAnswer(answers);

  const persona = gameQuestionsQuery.content[currentQuestion].answers.find(
    (item) => item.ident === dominantIdent,
  );
  const sideImageSrc =
    persona?.img ||
    gameQuestionsQuery.content[currentQuestion][
      width < 1020 ? "mobileImg" : "desktopImg"
    ];

  console.log(dominantIdent);

  return (
    <section
      className={`game-page quiz-mechanics ${ident} ${
        isUltraInsider ? "ultra-insider" : ""
      }`}
    >
      <div>
        <PagesHeader back>
          <p
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(gameQuestionsQuery?.title),
            }}
          ></p>
        </PagesHeader>
        <div className="main-game-wrppaer">
          <div className="desktop-wrapper">
            <LinearGradientProgressBar
              value={currentQuestion / gameQuestionsQuery.content.length}
            />
            <div className="game-question">
              <h2
                className="question"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(
                    gameQuestionsQuery.content[currentQuestion].question ||
                      persona.question,
                  ),
                }}
              />
            </div>
            <div
              className={`answer-content ${ident} ${
                gameQuestionsQuery.content[currentQuestion].imgAnswers
                  ? "imgAnswer"
                  : ""
              }`}
            >
              <div className="content-info-wrapper">
                <div
                  className="persona-content"
                  dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(persona.answer)}}
                />
              </div>
            </div>
          </div>
          <div className="side-img">
            <BrandLogo brands={gameQuestionsQuery?.brands} />
            {gameQuestionsQuery.content[currentQuestion].desktopImgHid ? (
              selected ===
              gameQuestionsQuery.content[currentQuestion].correctAnswer ? (
                <img src={sideImageSrc} alt="" />
              ) : (
                <img
                  src={
                    gameQuestionsQuery.content[currentQuestion][
                      width < 1020 ? "mobileImgHid" : "desktopImgHid"
                    ]
                  }
                  alt=""
                />
              )
            ) : (
              <div className="img-wrapper">
                <img src={sideImageSrc} alt="" />
                {gameQuestionsQuery.content[currentQuestion]?.sideImageCopy && (
                  <p
                    dangerouslySetInnerHTML={{
                      __html:
                        DOMPurify.sanitize(gameQuestionsQuery.content[currentQuestion]
                          ?.sideImageCopy),
                    }}
                  />
                )}
              </div>
            )}
            {XGA && (
              <StickyContent>
                <div className="desktop-buttons">
                  <Button action={handleNextButtonClick}>
                    {gameQuestionsQuery.content[currentQuestion]
                      .nextButtonCopy ?? "Nächste"}
                  </Button>
                </div>
              </StickyContent>
            )}
          </div>
        </div>
      </div>
      {!XGA && (
        <StickyButton action={handleNextButtonClick}>
          {gameQuestionsQuery.content[currentQuestion].nextButtonCopy ??
            "Nächste"}
        </StickyButton>
      )}
    </section>
  );
}
